export class ListGdsgInventoryReportRunsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runs",
            "baseName": "runs",
            "type": "Array<GdsgInventoryReportRun>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGdsgInventoryReportRunsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
